import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../scripts/control';

const LoginPage = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAdminAuth(); // Función login para actualizar el estado
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/login.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
        // Guardamos la información en localStorage
        localStorage.setItem('loggedIn', 'true');
        localStorage.setItem('role', data.role);
        login(data.role);     
        } else {
          setError('Credenciales inválidas');
        }
      } else {
        setError('Error al iniciar sesión');
      }
    } catch (error) {
      setError('Ocurrió un error. Por favor, inténtalo nuevamente.');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input 
          type="text" 
          placeholder="Usuario" 
          value={username} 
          onChange={(e) => setUsername(e.target.value)} 
          style={{ marginBottom: '10px', padding: '10px', width: 'auto', marginLeft: '10px', marginTop: '10px' }}
        />
        <div style={{ position: 'relative', marginBottom: '10px', marginLeft: '10px' }}>
          <input 
            type={showPassword ? "text" : "password"}
            placeholder="Contraseña" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            style={{ padding: '10px', width: 'auto' }}
          />
          <button 
            type="button" 
            onClick={togglePasswordVisibility} 
            style={{
              position: 'relative',
              right: '35px',
              top: '10px',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#555',
            }}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>
        </div>
        <button type="submit" style={{ padding: '10px 20px', marginLeft: '10px' }}>Login</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default LoginPage;
